// Two opponents a week (scenario Q6, B-614): a line under a team's two games
// saying what they are while they are played, and the week's record once
// both are final. One score, two results.

import { weekRecordOf, type MatchupSummary } from '@fsp/domain';
import { Text } from '../../kit/ui';
import { recordText } from '../schedule/season';

/** My side's team in a game of mine, or the home side's when neither is mine. */
export function mineIn(m: MatchupSummary): string {
  return m.away.team.isMine ? m.away.team.id : m.home.team.id;
}

export function TwoGamesNote({ games }: { games: readonly MatchupSummary[] }) {
  const first = games[0];
  if (first === undefined || games.length < 2) return null;
  const record = weekRecordOf(games, mineIn(first));
  return (
    <Text size="sm" tone="secondary" block>
      {record === null
        ? 'Two games this week: your one score against each team.'
        : `${recordText(record)} in your two games this week.`}
    </Text>
  );
}
